module.exports = __webpack_public_path__ + "static/media/LP7.eb19e6ff.svg";